import React, { ReactNode } from "react";

import ButtonArray, { ButtonType } from "@/App/components/ButtonArray";

interface Props {
  leftButtonSelected?: boolean;
  rightButtonSelected?: boolean;
  leftButtonAction: string;
  rightButtonAction: string;
  leftButtonContent: ReactNode;
  rightButtonContent: ReactNode;
}

const ToggleTabHeader: React.FC<Props> = (props: Props) => {
  const {
    leftButtonSelected = false,
    leftButtonAction,
    rightButtonAction,
    rightButtonSelected = false,
    leftButtonContent,
    rightButtonContent,
  } = props;

  const tabButtons: Array<ButtonType> = [
    {
      className: "tab-header-button-left",
      selected: leftButtonSelected,
      content: leftButtonContent,
      buttonType: "router-link",
      action: leftButtonAction,
    },
    {
      className: "tab-header-button-right",
      selected: rightButtonSelected,
      content: rightButtonContent,
      buttonType: "router-link",
      action: rightButtonAction,
    },
  ];

  return (
    <div className="tab-header-button-alignment">
      <ButtonArray buttons={tabButtons}/>
    </div>
  );
};

export default ToggleTabHeader;
